import { useNavigate } from "react-router-dom";
import { MapPin, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { useI18n } from "@/i18n/I18nContext";
import { COMPANY } from "@/i18n/translations";

export default function Footer() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const links = ["products", "about", "contact"];

  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto grid max-w-[1400px] grid-cols-1 gap-10 px-5 py-16 md:grid-cols-12 md:px-10">
        <div className="md:col-span-5">
          <Logo onClick={() => navigate("/")} />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-muted-foreground">
            {t("footer.tagline")}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="mb-4 text-[10px] uppercase tracking-[0.3em] text-muted-foreground">{t("footer.nav")}</p>
          <ul className="space-y-2.5">
            {links.map((l) => (
              <li key={l}>
                <button
                  onClick={() => document.querySelector(`#${l === "products" ? "products" : l}`)?.scrollIntoView({ behavior: "smooth" })}
                  className="text-sm text-foreground/80 transition-colors hover:text-primary"
                >
                  {t(`nav.${l}`)}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <p className="mb-4 text-[10px] uppercase tracking-[0.3em] text-muted-foreground">{t("footer.contact")}</p>
          <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(COMPANY.mapQuery)}`}
            target="_blank" rel="noopener noreferrer"
            className="flex items-start gap-2 text-sm text-foreground/80 transition-colors hover:text-primary">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0" /> {COMPANY.address}
          </a>
          <a href={`tel:${COMPANY.phoneIntl}`}
            className="mt-3 flex items-center gap-2 text-sm text-foreground/80 transition-colors hover:text-primary">
            <Phone className="h-4 w-4" /> {COMPANY.phone}
          </a>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-2 px-5 py-6 text-xs text-muted-foreground md:flex-row md:px-10">
          <p>© {new Date().getFullYear()} {COMPANY.name} {COMPANY.suffix}. {t("footer.rights")}</p>
          <p>{t("footer.made")}</p>
        </div>
      </div>
    </footer>
  );
}
